<template>


    <section
        class="relative overflow-hidden bg-gradient-to-br from-lime-bright via-yellow-bright to-orange-200">
        <!-- Background decorative elements -->

        <div class="absolute top-0 left-0 w-full h-full">

            <nuxt-img src="/assets/images/mindflow-hero-1.png" sizes="xs:340px sm:450ppx md:766px lg:1023px xl:1200px"
                preload fetchpriority="high" loading="eager" width="1920" height="1157" alt="hero-image" format="webp"
                class="object-cover w-full h-full" />

        </div>

        <!-- Header -->
      

        <!-- Main Content -->
        <div class="relative z-10 max-w-6xl pt-6 pb-12 mx-auto sm:px-4 md:pb-24 md:pt-12 xl:px-0">
            <!-- Hero Section -->
            <div class="max-w-4xl mx-auto mb-4 text-center md:mb-8">
                <h1 class="mb-4 text-5xl font-bold md:text-6xl xl:text-7xl font-ww-bold">
                    {{ mainHeading }}
                </h1>
                <h2 class="px-4 mb-2 text-3xl font-semibold md:px-16 md:text-4xl xl:text-5xl">
                    {{ subHeading }}
                </h2>
          

            </div>

            <div class="text-xl italic text-center xl:text-3xl md:text-2xl lmx-auto font-ww-regular">
                {{ italicText }}
            </div>

            <!-- Content Section -->
            <div class="grid items-center mx-auto mt-8 lg:mt-16 max-w-7xl lg:grid-cols-2 gap-y-6 xl:gap-x-0 md:gap-x-6">
                <!-- Video Player -->
                <div class="relative">
                    <div
                        class="relative flex items-center justify-center max-w-3xl mx-auto overflow-hidden shadow-2xl cursor-pointer sm:rounded-lg aspect-video lg:max-w-auto">


                        <div class="absolute top-0 left-0 w-full h-full" style="background: linear-gradient(290.86deg, #B4A7D6 39.69%, #EED6B7 83.04%);">

                        </div>

                        <video 
                            ref="videoPlayer"
                            id="myVideo" 
                            class="absolute top-0 left-auto w-auto h-full p-2 md:p-2 rounded-3xl" 
                            allow="autoplay; fullscreen" 
                            loop
                            preload="none"
                            sizes="xs:303px sm:400px md:750px lg:1023px xl:1100px 2xl:1200px" 
                            playsinline>
                        </video>

                        <div 
                            ref="playButton"
                            @click="handlePlayVideo"
                            class="z-10 transition-opacity duration-300 cursor-pointer play-button">
                            <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="37.4411" cy="37.4411" r="37.4411" fill="#F1574B" />
                                <path
                                    d="M29.6619 24.455C29.2032 24.1925 28.707 24.4108 28.707 24.9397V49.9424C28.707 50.4713 29.2032 50.6896 29.6619 50.427L51.6124 37.918C52.072 37.6555 52.0413 37.2266 51.5826 36.964L29.6619 24.455Z"
                                    fill="white" />
                            </svg>
                        </div>

                    </div>
                </div>

                <!-- Lead Capture Form -->
           <div class="mx-4 sm:mx-0">
            <div class="w-full px-4 py-6 mx-auto bg-white rounded-lg shadow-2xl xl:max-w-lg sm:px-8 md:py-10 lg:px-12 xl:px-14 xl:ml-16">
                    <h3 class="mb-2 text-2xl font-bold text-center xl:text-3xl md:text-2xl font-ww-bold">
                        {{ formTitle }}
                    </h3>
                    <div class="px-4 mx-auto mb-6 text-base text-center !leading-6 sm:px-12 xl:text-lg max-w-70 font-ww-regular">
                        {{ formSubtitle }}
                    </div>

                    <form class="space-y-4" :action="formSubmitAction" method="POST">



                        <div class="relative">
                            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M14.1893 10.3802C15.0942 9.37223 15.6497 8.04485 15.6497 6.58729C15.6497 3.44952 13.0967 0.896484 9.95891 0.896484C6.82114 0.896484 4.26811 3.44952 4.26811 6.58729C4.26811 9.72506 6.82114 12.2781 9.95891 12.2781C11.0651 12.2781 12.0951 11.9559 12.9701 11.4074C16.0644 12.5733 18.1949 15.4052 18.466 18.6803H1.45258C1.63682 16.4758 2.67112 14.42 4.35347 12.9532C4.6501 12.6949 4.68069 12.2461 4.42247 11.9495C4.16496 11.6535 3.71539 11.6222 3.41875 11.8805C1.24558 13.7741 0 16.5113 0 19.3916C0 19.785 0.318685 20.103 0.711351 20.103H19.2065C19.5998 20.103 19.9178 19.785 19.9178 19.3916C19.9178 15.4891 17.6557 12.0042 14.1893 10.3802ZM5.69081 6.58729C5.69081 4.23343 7.60505 2.31919 9.95891 2.31919C12.3128 2.31919 14.227 4.23343 14.227 6.58729C14.227 8.94115 12.3128 10.8554 9.95891 10.8554C7.60505 10.8554 5.69081 8.94115 5.69081 6.58729Z"
                                        fill="#C4C4C4" />
                                </svg>

                            </div><input
                                class="flex h-12 px-3 py-2 pl-10 xl:text-lg text-base font-ww-regular bg-[#F0F0F0] rounded-lg w-full"
                                :placeholder="firstNamePlaceholder" type="text">
                        </div>



                        <div class="relative">
                            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.1986 5.07617C19.9843 5.07617 19.7788 5.16129 19.6273 5.31281C19.4757 5.46433 19.3906 5.66983 19.3906 5.88411V12.3477C19.3906 12.5619 19.3055 12.7674 19.154 12.919C19.0025 13.0705 18.797 13.1556 18.5827 13.1556H2.42383C2.20955 13.1556 2.00405 13.0705 1.85253 12.919C1.70101 12.7674 1.61589 12.5619 1.61589 12.3477V5.88411C1.61589 5.66983 1.53076 5.46433 1.37924 5.31281C1.22773 5.16129 1.02222 5.07617 0.807943 5.07617C0.593663 5.07617 0.38816 5.16129 0.236641 5.31281C0.0851223 5.46433 0 5.66983 0 5.88411V12.3477C0.000565728 12.9903 0.256304 13.6064 0.71099 14.0605C1.16511 14.5152 1.78121 14.7709 2.42383 14.7715H18.5827C19.2253 14.7709 19.8414 14.5152 20.2955 14.0605C20.7502 13.6064 21.0059 12.9903 21.0065 12.3477V5.88411C21.0065 5.66983 20.9214 5.46433 20.7699 5.31281C20.6184 5.16129 20.4128 5.07617 20.1986 5.07617Z" fill="#C4C4C4"/>
<path d="M10.0188 9.76224C10.1586 9.86713 10.3287 9.92383 10.5035 9.92383C10.6783 9.92383 10.8484 9.92383 10.9883 9.76224L20.5301 2.60387C20.6789 2.49162 20.7844 2.33135 20.8286 2.15023C20.8728 1.9691 20.8529 1.77827 20.7725 1.6101C20.6521 1.36151 20.491 1.13484 20.2958 0.939505C19.8417 0.484819 19.2256 0.229081 18.5829 0.228516H2.42409C1.78147 0.229081 1.16538 0.484819 0.711256 0.939505C0.516021 1.13484 0.354895 1.36151 0.23457 1.6101C0.154112 1.77827 0.134291 1.9691 0.178467 2.15023C0.222644 2.33135 0.328098 2.49162 0.476952 2.60387L10.0188 9.76224ZM2.42409 1.8444H18.5829C18.6579 1.8326 18.7342 1.8326 18.8092 1.8444L10.5035 8.10596L2.19787 1.8444C2.27282 1.8326 2.34915 1.8326 2.42409 1.8444Z" fill="#C4C4C4"/>
</svg>

                            </div>
                            <input
                                class="flex w-full h-12 px-3 py-2 pl-10 xl:text-lg text-base font-ww-regular bg-[#F0F0F0] rounded-lg"
                                :placeholder="emailPlaceholder" type="email">
                        </div>
                        <button type="submit"
                            class="w-full py-3 mt-5 font-semibold text-white btn-red font-ww-bold">
                            {{ submitButtonText }}
                        </button>
                    </form>
                </div>
           </div>
            </div>
        </div>


    </section>

</template>

<script setup>

const props = defineProps({
  mainHeading: {
    type: String,
    default: 'Want A Brain Glow Up?',
  },
  subHeading: {
    type: String,
    default: '4 Tiny Tweaks To Think Faster — #1 Takes Just 20 Seconds',
  },
  italicText: {
    type: String,
    default: 'Notes from a Doctor that has been biohacking his brain for over a decade',
  },
  formTitle: {
    type: String,
    default: 'Grab Your Free Copy',
  },
  formSubtitle: {
    type: String,
    default: 'Four Easy Steps To Better Brain Health - No Matter What Your Age',
  },
  videoUrl: {
    type: String,
    default: 'https://cdn.shopify.com/videos/c/o/v/f113f00d8c5d4d978e2a9a6bff477232.mp4',
  },
  firstNamePlaceholder: {
    type: String,
    default: 'First Name',
  },
  emailPlaceholder: {
    type: String,
    default: 'Email',
  },
  submitButtonText: {
    type: String,
    default: 'Submit',
  },
  formSubmitAction: {
    type: String,
    default: '',
  }
});

const videoPlayer = ref(null);
const playButton = ref(null);

const handlePlayVideo = () => {
  if (videoPlayer.value) {
    // Set video source when play is clicked
    videoPlayer.value.src = props.videoUrl;
    // Load and play the video
    videoPlayer.value.load();
    videoPlayer.value.play();
    // Add controls after video starts playing
    videoPlayer.value.controls = true;
    // Hide the play button with animation
    playButton.value.style.opacity = '0';
    setTimeout(() => {
      playButton.value.style.display = 'none';
    }, 300);
  }
};

defineBuilderComponent({
  friendlyName: 'VideoSignup',
  inputs: [
    {
      name: 'mainHeading',
      type: 'richText',
      friendlyName: 'Main Heading',
      defaultValue: 'Want A Brain Glow Up?',
    },
    {
      name: 'subHeading',
      type: 'richText',
      friendlyName: 'Sub Heading',
      defaultValue: '4 Tiny Tweaks To Think Faster — #1 Takes Just 20 Seconds',
    },
    {
      name: 'italicText',
      type: 'text',
      friendlyName: 'Italic Text',
      defaultValue: 'Notes from a Doctor that has been biohacking his brain for over a decade',
    },
    {
      name: 'formTitle',
      type: 'text',
      friendlyName: 'Form Title',
      defaultValue: 'Grab Your Free Copy',
    },
    {
      name: 'formSubtitle',
      type: 'text',
      friendlyName: 'Form Subtitle',
      defaultValue: 'Four Easy Steps To Better Brain Health - No Matter What Your Age',
    },
    {
      name: 'videoUrl',
      type: 'text',
      friendlyName: 'Video URL',
      defaultValue: 'https://cdn.shopify.com/videos/c/o/v/f113f00d8c5d4d978e2a9a6bff477232.mp4',
    },
    {
      name: 'firstNamePlaceholder',
      type: 'text',
      friendlyName: 'First Name Placeholder',
      defaultValue: 'First Name',
    },
    {
      name: 'emailPlaceholder',
      type: 'text',
      friendlyName: 'Email Placeholder',
      defaultValue: 'Email',
    },
    {
      name: 'submitButtonText',
      type: 'text',
      friendlyName: 'Submit Button Text',
      defaultValue: 'Submit',
    },
    {
      name: 'formSubmitAction',
      type: 'text',
      friendlyName: 'Form Submit Action URL',
      defaultValue: '',
    }
  ],
});
</script>